import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import UserService from '../../../../services/user/UserService'
import { AsyncPaginate } from 'react-select-async-paginate'
import KapalService from '../../../../services/kapal/KapalService'

const ModalAddEditEvaluasiTeknis = ({ showEvaluasiTeknis, handleCloseEvaluasiTeknis, dataPpmKapal, dataEvaluasi, setListEvaluasi, isEdit }) => {

    let userService = useMemo(() => new UserService(), [])
    let kapalService = useMemo(() => new KapalService(), [])

    const [valueCatatan, setValueCatatan] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)
    const [valueTglEvaluasi, setValueTglEvaluasi] = useState(null)
    const [valueGradeUsulOpt, setValueGradeUsulOpt] = useState(null)

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            const resKapalIkan = await kapalService.listKapalIkanKomoditi(dataPpmKapal.nomorAjuKapal)
            const resJenisKomoditi = await kapalService.listJenisKomoditi(null, 0, 20)
            const optionsJenis = resJenisKomoditi.data.data

            const mappedSelected = resKapalIkan.data.data.map(item => {
                const found = optionsJenis.find(
                    opt => opt.idJenisKomoditi === item.idJenisKomoditi
                );

                if (!found) return null; // handle jika tidak ketemu

                return {
                    idJenisKomoditi: found.idJenisKomoditi,
                    urJenisKomoditi: found.urJenisKomoditi,
                    urJenisKomoditiEn: found.urJenisKomoditiEn
                }
            }).filter(Boolean)
            setValueJenisKomoditiOpt(mappedSelected)
        }
        fetchAllData()
    }, [dataPpmKapal, kapalService])

    useEffect(() => {
        if (!dataEvaluasi) return
        const fetchAllData = async () => {
            try {
                setValueCatatan(dataEvaluasi.catatanEvaluator)
                setValueTglEvaluasi(dataEvaluasi.tglEvaluasi)

                const resPegawai = await userService.getPegawaiById(dataEvaluasi.nipEvaluator)
                setValuePegawaiOpt(resPegawai.data)

                const optionsGrade = [{ value: 'A', label: 'A' }, { value: 'B', label: 'B' }, { value: 'C', label: 'C' }, { value: 'D', label: 'D' }, { value: 'Non Grade', label: 'Non Grade' }]
                setValueGradeUsulOpt(optionsGrade.find(option => option.value === dataEvaluasi.gradeUsul))

                let listIdKomoditi = null
                const resKapalIkan = await kapalService.listKapalIkanKomoditi(dataPpmKapal.nomorAjuKapal)
                const resEvalTeknisProduk = await kapalService.listEvaluasiTeknisProduk(dataEvaluasi.idInspeksiEvaluasi, dataPpmKapal.nomorAjuKapal)
                if (resEvalTeknisProduk) {
                    listIdKomoditi = resEvalTeknisProduk.data.data
                } else {
                    listIdKomoditi = resKapalIkan && resKapalIkan.data.data
                }

                const resJenisKomoditi = await kapalService.listJenisKomoditi(null, 0, 20)
                const optionsJenis = resJenisKomoditi.data.data

                const mappedSelected = listIdKomoditi.map(item => {
                    const found = optionsJenis.find(
                        opt => (opt.idJenisKomoditi === item.idJenisKomoditi || opt.idJenisKomoditi === item.idKomoditi)
                    );

                    if (!found) return null; // handle jika tidak ketemu

                    return {
                        idJenisKomoditi: found.idJenisKomoditi,
                        urJenisKomoditi: found.urJenisKomoditi,
                        urJenisKomoditiEn: found.urJenisKomoditiEn
                    }
                }).filter(Boolean)
                setValueJenisKomoditiOpt(mappedSelected)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [dataEvaluasi, userService, kapalService, dataPpmKapal])

    const [valueJenisKomoditiOpt, setValueJenisKomoditiOpt] = useState(null)
    async function loadOptionJenisKomoditi(search, loadedOption, { page = 1 }) {
        const response = await kapalService.listJenisKomoditi(search, page, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            addition: {
                page: page + 1
            }
        }
    }
    const onChangeJenisKomoditi = e => {
        setValueJenisKomoditiOpt(e)
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, '00.3', page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePegawai = e => {
        setValuePegawaiOpt(e)
    }
    const handleChangeTglEvaluasi = e => {
        setValueTglEvaluasi(e.target.value)
    }
    const handleChangeCatatan = e => {
        // console.log(valueJenisKomoditiOpt)
        setValueCatatan(e.target.value)
    }

    async function loadOptionGrade(search, loadedOption, page) {
        const options = [
            {
                value: 'A',
                label: 'A'
            },
            {
                value: 'B',
                label: 'B',
            },
            {
                value: 'C',
                label: 'C'
            },
            {
                value: 'D',
                label: 'D'
            },
            {
                value: 'Non Grade',
                label: 'Non Grade'
            }
        ]
        return {
            options: options
        }
    }
    const handleChangeGrade = e => {
        setValueGradeUsulOpt(e)
    }

    const handleClickSimpan = () => {
        const jsonEvaluasi = {
            ...dataEvaluasi,
            nipEvaluator: valuePegawaiOpt.nip,
            nmEvaluator: valuePegawaiOpt.nama,
            tglEvaluasi: valueTglEvaluasi,
            catatanEvaluator: valueCatatan,
            gradeUsul: valueGradeUsulOpt.value,
            jenisKomoditi: valueJenisKomoditiOpt,
            createdBy: localStorage.getItem("userId"),
            createdDate: new Date()
        }
        setListEvaluasi(prevList => {
            const index = prevList.findIndex(item => item.nomorAjuKapal === dataPpmKapal.nomorAjuKapal && item.nipEvaluator === valuePegawaiOpt.nip)
            let newList
            if (index !== -1) {
                newList = [...prevList]
                newList[index] = { ...jsonEvaluasi }
            } else {
                newList = [...prevList, jsonEvaluasi]
            }
            return newList.map((item, idx) => ({ ...item, nomorAjuKapal: dataPpmKapal.nomorAjuKapal }))
        })
        handleCloseEvaluasiTeknis()
    }

    const handleClickClose = () => {
        handleCloseEvaluasiTeknis()
    }

    return (
        <>
            <Modal
                show={showEvaluasiTeknis}
                onHide={handleCloseEvaluasiTeknis}
                size='lg'
                centered
            >
                <Modal.Header closeButton><h6>Evaluasi Tim Teknis</h6></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Komoditi</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionJenisKomoditi}
                                            value={valueJenisKomoditiOpt}
                                            getOptionValue={(option) => option.idJenisKomoditi}
                                            getOptionLabel={(option) => option.urJenisKomoditi + ' - ' + option.urJenisKomoditiEn}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeJenisKomoditi}
                                            isDisabled={!isEdit}
                                            isMulti
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan Tim Teknis</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" rows={5} placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={handleChangeCatatan} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Usulan Grade</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionGrade}
                                            value={valueGradeUsulOpt}
                                            getOptionValue={(option) => option.value}
                                            getOptionLabel={(option) => option.label}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={handleChangeGrade}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Evaluasi</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="date" placeholder="Tanggal" className="form-control-sm" value={valueTglEvaluasi} onChange={handleChangeTglEvaluasi} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Evaluator</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionPegawai}
                                            value={valuePegawaiOpt}
                                            getOptionValue={(option) => option.nip}
                                            getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangePegawai}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleClickSimpan()}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalAddEditEvaluasiTeknis